// extracted by mini-css-extract-plugin
export default {"block":"AaQ73ilx4txWlK_rYdoV","blockHeader":"baJZL01jhHsbCBbFZEkV","blockBody":"_UMv4nspQRiC4h1BgVtR","blockBodyRow":"z2chy8C6n2VYgu8R97Zg","blockBodyRowItem":"s9gdHwkOkPDx2attEX_3"};